<script>
import store from '@state/store'
import { Carousel, Slide } from 'vue-carousel'
import Layout from '@layouts/loggedin.vue'
import EventsSideBar from '@events/components/events-side-bar.vue'
import CompanyHeader from '@companies/components/company-header.vue'
import PostFormWrapper from '@companies/components/post-form-wrapper.vue'
import { authComputed } from '@state/helpers'
import PostFeed from '@router/components/post-feed.vue'
import EventsFilter from '@companies/components/events-filter.vue'
import { POSTS_PER_PAGE } from '@/src/router/constant'

export default {
  components: {
    Layout,
    EventsSideBar,
    CompanyHeader,
    PostFormWrapper,
    PostFeed,
    Carousel,
    Slide,
    EventsFilter,
  },
  props: {
    companyId: {
      type: Number,
      required: true,
    },
    routeFrom: {
      type: String,
      required: false,
      default: '',
    },
    postsCount: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loadingMore: false,
      noMorePosts: false,
      showDefaultCompanyPicker: false,
      defaultCompanyId: 0,
      defaultCompanyFlag: false,
    }
  },
  computed: {
    ...authComputed,
    statusUpdates() {
      return this.$store.state.companies.statusUpdates || []
    },
    currentCompany() {
      let currentCompany = false
      if (this.currentUser) {
        for (
          let index = 0;
          index < this.currentUser.companies.length;
          index++
        ) {
          if (this.currentUser.companies[index].id === this.companyId) {
            currentCompany = this.currentUser.companies[index]
          }
        }
      }
      return currentCompany
    },
  },
  mounted() {
    this.checkDefaultHub()
  },
  methods: {
    checkDefaultHub() {
      if (
        (this.routeFrom === 'login' ||
          this.routeFrom === 'verify-phone' ||
          this.routeFrom === 'login-by-phone') &&
        this.currentUser.default_company_id === 0
      ) {
        this.showDefaultCompanyPicker = true
      }
    },
    onClose() {
      this.showDefaultCompanyPicker = false
    },
    chooseDefaultCompany(company) {
      this.defaultCompanyId = company.id
      if (!this.defaultCompanyFlag) {
        this.goToCompany()
        return
      }
      store
        .dispatch('auth/setDefaultCompany', {
          companyId: this.defaultCompanyId,
        })
        .finally(() => {
          this.goToCompany()
        })
    },
    goToCompany() {
      if (this.companyId === this.defaultCompanyId) {
        this.onClose()
      } else {
        this.$router.push({
          name: 'company',
          params: { companyId: this.defaultCompanyId },
        })
      }
    },
    fetchMoreStatusUpdates() {
      if (this.postsCount < POSTS_PER_PAGE) return (this.noMorePosts = true)

      this.loadingMore = true
      store
        .dispatch('companies/fetchStatusUpdates', {
          companyId: this.companyId,
        })
        .then((posts) => {
          this.loadingMore = false
          this.noMorePosts = !posts.length
        })
        .catch(() => {})
    },
  },
}
</script>

<template>
  <Layout>
    <BaseModalWindow
      v-if="showDefaultCompanyPicker"
      modalcls="w-set-default-company bg-white rounded-xl mx-auto px-11 shadow-box relative left-0 flex justify-between overflow-hidden"
      :visible="showDefaultCompanyPicker"
      @close="onClose"
    >
      <template v-slot:body>
        <div class="w-full mx-auto my-8 hub-selector">
          <h3 class="block pb-6 italic font-brandon text-blue-darker text-35xl">
            WHERE WOULD YOU LIKE TO GO FIRST?
          </h3>

          <div class="py-6 mb-4 border-t border-b border-gray-light">
            <div>
              <Carousel :per-page="3" pagination-active-color="#079bd7">
                <Slide
                  v-for="company in currentUser.companies"
                  :key="company.id"
                  :class="[
                    'hub-item cursor-pointer',
                    company.id === defaultCompanyId && 'hub-item-cur',
                  ]"
                  @slideclick="() => chooseDefaultCompany(company)"
                >
                  <div class="img-box">
                    <div>
                      <img :src="company.image_url" />
                    </div>
                  </div>
                  <div class="mt-4 text-center">{{ company.name }}</div>
                </Slide>
              </Carousel>
            </div>
          </div>
          <div class="flex justify-center">
            <label
              for="defaultCompanyCheckbox"
              class="flex items-center cursor-pointer text-sml text-blue"
            >
              <input
                id="defaultCompanyCheckbox"
                v-model="defaultCompanyFlag"
                type="checkbox"
                name="defaultCompanyCheckbox"
                class="mr-2 checkbox"
              />
              Make This My Default Place
            </label>
          </div>
        </div>
      </template>
    </BaseModalWindow>
    <CompanyHeader :company="currentCompany"></CompanyHeader>
    <div class="justify-between table pr-20 bg-white pt-15 pl-15">
      <div class="z-10 table-cell align-top w-new-post">
        <PostFormWrapper :company-id="companyId"> </PostFormWrapper>
        <div class="mt-5 text-xl">
          <span class="">Business or School</span>
          <span class="breadcrumb-separator">></span>
          <span class="text-blue">{{ currentCompany.name }}</span>
        </div>
      </div>
      <div class="table-cell w-full text-right">
        <div class="inline-block ml-auto mr-0">
          <router-link
            v-if="canEditCompany(currentCompany.id)"
            class="block w-48 h-12 mb-4 text-right button primary-button"
            :to="{ name: 'createNewEvent' }"
          >
            + Create An Event
          </router-link>
          <router-link
            :to="{
              name: 'companyEvents',
              params: { companyId: companyId },
            }"
            class="flex justify-between block w-48 h-12 mb-4 button primary-button"
            ><svg
              class="inline-block h-12 mr-2 align-middle"
              xmlns="http://www.w3.org/2000/svg"
              width="16.187"
              height="16.142"
              viewBox="0 0 16.187 16.142"
            >
              <defs></defs>
              <g transform="translate(17.622 0.071)">
                <path
                  fill="#FFFFFF"
                  d="M-1.673,14.693l-3.6-3.615a6.9,6.9,0,0,0-1.2-9.689,6.9,6.9,0,0,0-9.688,1.2,6.9,6.9,0,0,0,1.2,9.689,6.9,6.9,0,0,0,8.554-.051l3.6,3.611a.809.809,0,0,0,1.14,0h0A.809.809,0,0,0-1.673,14.693ZM-10.7,12.12a5.3,5.3,0,0,1-5.316-5.283,5.3,5.3,0,0,1,5.284-5.316A5.3,5.3,0,0,1-5.421,6.8v.019A5.3,5.3,0,0,1-10.7,12.12Z"
                />
              </g></svg
            ><span class="align-middle">Find An Event</span>
          </router-link>

          <EventsFilter :company-id="companyId" />
        </div>
      </div>
    </div>
    <div class="flex h-auto pt-6 pr-20 pl-15 bg-blue-lightest">
      <div
        class="left-posts w-7/12 max-w-1.95xl bg-white rounded-xl mr-17 shadow-box overflow-hidden"
      >
        <PostFeed
          :status-updates="statusUpdates"
          :loading-more="loadingMore"
          :no-more-posts="noMorePosts"
          @fetch-more-status-updates="fetchMoreStatusUpdates"
        ></PostFeed>
      </div>
      <EventsSideBar :company-id="companyId"></EventsSideBar>
    </div>
  </Layout>
</template>
